export enum ExclusionTypeIds {
    CrossReference = 1,
    Spec = 2,
    PartSpec = 3,
    PartPicCode = 4,
    PartBrand = 5,
    Part = 6,
    CrossOem = 7,
    PartAlternative = 8,
    RelatedPart = 9,
    Category = 10,
    CrossSearch = 11,
}
